import Cookies from 'js-cookie';
import { useCallback, useMemo } from 'react';

const SIXTY_DAYS = 60;
const APPLE_PAY_COOKIE_NAME = 'show_apple_pay_provision_modal';

const ONE_YEAR = 365;
const APPLE_PAY_DISMISS_COOKIE_NAME = 'apple_pay_provision_dismiss_modal_count';
const MAX_DISMISS_COUNT = 3;

const useApplePayCookies = () => {
    const { dismissCookieCount, showModal } = useMemo(() => {
        const dismissCookie = Cookies.get(APPLE_PAY_DISMISS_COOKIE_NAME);
        const dismissCookieCount = dismissCookie ? Number.parseFloat(dismissCookie) : 0;
        const isMaxDismissCount = dismissCookieCount >= MAX_DISMISS_COUNT;
        const showModal = !isMaxDismissCount && Cookies.get(APPLE_PAY_COOKIE_NAME) === undefined;

        return { dismissCookieCount, showModal };
    }, []);

    const setCookies = useCallback(
        (isSuccessOrError: boolean) => {
            if (!isSuccessOrError) {
                Cookies.set(APPLE_PAY_DISMISS_COOKIE_NAME, (dismissCookieCount + 1).toString(), {
                    expires: ONE_YEAR,
                });
            }
            Cookies.set(APPLE_PAY_COOKIE_NAME, 'closed', { expires: SIXTY_DAYS });
        },
        [dismissCookieCount],
    );

    return { showModal, setCookies };
};

export default useApplePayCookies;
